import { QueryClient } from '@tanstack/react-query';

import { shouldRetryStorefrontQuery } from './retryPolicy';

/**
 * The storefront's TanStack Query client. Plan/price data is public, recomputable
 * catalogue data with a short server-side cache in the BFF, so the client keeps a
 * modest stale window and does not retry aggressively on an anonymous edge.
 *
 * ⚠️ `retry` USED TO BE THE NUMBER `1`, WHICH RETRIED 4xx TOO. On a public,
 * IP-rate-limited edge that spends a shared allowance re-asking questions the
 * server has already answered definitively (401 / 403 / 404 / 429). It is now the
 * `retryPolicy` predicate: transient failures keep one retry, client errors get
 * none. See `retryPolicy.ts` for the QA finding that prompted this.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        retry: shouldRetryStorefrontQuery,
        refetchOnWindowFocus: false,
      },
    },
  });
}
